import homeFont from '../assets/images/homeInActive.svg';
import contactsListFont from '../assets/images/HouseholdsIcon.svg';
import routesFont from '../assets/images/RoutesIcon.svg';
import reportsFont from '../assets/images/TeamIcon.svg';
import tutorialsFonts from '../assets/fonts/tutorials.svg';
import duchotFont from '../assets/images/historyPrimary.svg';
import billing from '../assets/images/Billing.svg';
import settingsIcon from '../assets/images/settings.svg';
import downloadIcon from '../assets/fonts/download.svg';
import volunteeringFont from '../assets/images/VolunteeringIcon.svg';


export const routes = [
    {
        route: "contacts",
        icon: contactsListFont,
        link: "/households",
        group: "general",
        permission: "read_households",
        scopeType: "households",
    },
    {
        route: "map",
        icon: homeFont,
        link: "/map",
        group: "general",
        permission: "read_map",
        scopeType: "",
    },
    {
        route: "saved_routes",
        icon: routesFont,
        link: "/saved-routes",
        group: "general",
        permission: "read_routes",
        scopeType: "routes",
    },
    {
        route: "duchot",
        icon: duchotFont,
        link: "/duchot",
        group: "general",
        permission: "read_duchot",
        scopeType: "",
    },
    {
        route: "my_team",
        icon: reportsFont,
        link: "/my-team",
        group: "general",
        permission: "read_my_team",
        scopeType: "",
    },
    {
        route: "tutorials",
        icon: tutorialsFonts,
        link: "#",
        modal: "tutorials",
        group: "general",
        // Task 18 fix: this was permission: "" (shown to every signed-in user
        // unconditionally), which put it on a volunteer-only account's sidebar
        // alongside Volunteering -- the ONE entry that role is supposed to
        // see (RoleSeeder's own comment on the `volunteer` role: "the shell
        // shows him nothing else because every sidebar entry is
        // permission-gated" -- this one simply wasn't). A tutorial for using
        // households/routes/visits has nothing to teach someone whose entire
        // app is the self-explanatory /volunteering page, so it is gated on
        // the same baseline permission every real account holder already has.
        permission: "read_households",
        scopeType: "",
    },
    {
        route: "billing",
        icon: billing,
        link: "/billing",
        group: "general",
        permission: "read_billing",
        scopeType: "",
    },
    {
        route: "emergency_export",
        icon: downloadIcon,
        link: "#",
        group: "general",
        permission: "",
        scopeType: "",
        modal: "export",
    },
    {
        route: "volunteering",
        icon: volunteeringFont,
        link: "/volunteering",
        group: "general",
        permission: "manage_volunteering",
        // Owner decision, 2026-09-08: the entry appears only once someone
        // actually offers help. `manage_volunteering` alone is not enough --
        // every anash holds it, and none of them asked for a new sidebar item.
        // The extra condition (see src/utils/showsVolunteering.ts, imported by
        // the sidebar renderer) is deliberately NOT hand-copied here -- this
        // file stays plain JS with no types, so the predicate lives in its own
        // TS file rather than as a hand-maintained guard list.
        requiresVolunteerConnection: true,
        scopeType: "",
    },
];

// Admin routes - only visible to Super Admin
export const adminRoutes = [
    {
        route: "dashboard",
        icon: homeFont,
        link: "/admin/dashboard",
        group: "admin",
        permission: "read_admin_workspaces",
        scopeType: "",
    },
    {
        route: "manage_workspaces",
        icon: contactsListFont,
        link: "/admin/workspaces",
        group: "admin",
        permission: "read_admin_workspaces",
        scopeType: "",
    },
    {
        route: "manage_users",
        icon: reportsFont,
        link: "/admin/users",
        group: "admin",
        permission: "read_admin_users",
        scopeType: "",
    },
    {
        route: "manage_packages",
        icon: routesFont,
        link: "/admin/packages",
        group: "admin",
        permission: "read_admin_packages",
        scopeType: "",
    },
    {
        route: "manage_uploads",
        icon: settingsIcon,
        link: "/admin/managed-uploads",
        group: "admin",
        permission: "read_admin_packages",
        scopeType: "",
    },
    {
        route: "pending_users",
        icon: reportsFont,
        link: "/admin/pending-users",
        group: "admin",
        permission: "read_admin_users",
        scopeType: "",
    },
    {
        // The Chabad Centres console: the approval queue for newly proposed
        // centres, the flagged-address repair list, and the address-change
        // requests a Shliach raises for a centre he is connected to.
        //
        // The page and its route (App/index.tsx, "admin/centers") existed
        // before this entry did, so the only way to reach it was to type the
        // URL — a super admin looking at the sidebar had no way to know it was
        // there at all. Same permission the route itself guards on, so the
        // link can never appear to someone the page would then refuse.
        route: "manage_centers",
        icon: contactsListFont,
        link: "/admin/centers",
        group: "admin",
        permission: "read_admin_users",
        scopeType: "",
    },
    {
        // Shliachim waiting to be confirmed at the centre they named at signup.
        // Its own entry, not a tab on the centres console, because it is its own
        // decision — and because the endpoint behind it had no screen at all
        // until now, so every request ever made was still sitting there.
        route: "center_connections",
        icon: contactsListFont,
        link: "/admin/center-connections",
        group: "admin",
        permission: "read_admin_users",
        scopeType: "",
    },
];
